//砂石资讯定义

import UltMeta, { Meta } from "./UltMeta/index";

class Type extends UltMeta {
    IMG = new Meta(1, "图片");
    VIDEO = new Meta(2, "视频");
}

export const TYPE = new Type();

/**
 * 分类
 */
class Classify extends UltMeta {
    /**
     * 行业动态
     */
    INDUSTRY_TRENDS = new Meta(1, "行业动态");
    /**
     * 分析报告
     */
    ANALYSIS_REPORT = new Meta(2, "分析报告");
    /**
     * 每日评述
     */
    DAILY_REVIEW = new Meta(3, "每日评述");
    /**
     * 水位信息
     */

    WATER_LEVEL = new Meta(4, "水位信息");
    /**
     * 航道通告
     */

    WATERWAY_NOTICE = new Meta(5, "航道通告");
    /**
     * 白露专区
     */
    BAI_LU = new Meta(6, "白露专区");
}

export const CLASSIFY = new Classify();

/** 链云展示资讯分类 **/
class ShowClassify extends UltMeta {
    INDUSTRY_TRENDS = new Meta(1, "砂石动态");
    ANALYSIS_REPORT = new Meta(2, "分析报告");
    DAILY_REVIEW = new Meta(3, "每日评述");
    BAI_LU = new Meta(6, "白露专区");
}

export const SHOW_CLASSIFY = new ShowClassify();

/**
 * 资讯类别
 */
class FeeType extends UltMeta {
    /**
     * 免费内容
     */
    FREE_CONTENT = new Meta(1, "免费内容");
    /**
     * 会员专享
     */
    VIP_EXCLUSIVE = new Meta(2, "会员专享");
}

export const INFORMATION_FEE_TYPE = new FeeType();

/**
 * 展示位置
 */
class ShowLocationType extends UltMeta {
    Show_Location_One = new Meta(1, "链云移动端首页资讯1");
    Show_Location_Two = new Meta(2, "链云移动端首页资讯2");
    Show_Location_Three = new Meta(3, "链云移动端首页资讯3");
    Show_Location_Four = new Meta(4, "链云移动端首页资讯4");
    Show_Location_Five = new Meta(5, "链云移动端首页资讯5");
}
export const Show_Location_Type = new ShowLocationType();

/**
 * PC展示位置
 */
class ShowPCLocationType extends UltMeta {
    Show_Location_One = new Meta(1, "用户PC首页1");
    Show_Location_Two = new Meta(2, "用户PC首页2");
    Show_Location_Three = new Meta(3, "用户PC首页3");
    Show_Location_Four = new Meta(4, "用户PC首页4");
    Show_Location_Five = new Meta(5, "用户PC首页5");
    Show_Location_Six = new Meta(6, "用户PC首页6");
    Show_Location_Seven = new Meta(7, "用户PC首页7");
    Show_Location_Eight = new Meta(8, "用户PC首页8");
}
export const Show_PC_Location_Type = new ShowPCLocationType();

/**
 * PC展示位置
 */
class ShowUserPCType extends UltMeta {
    Show_Location_One = new Meta(1, "链云PC端看资讯-精选资讯1");
    Show_Location_Two = new Meta(2, "链云PC端看资讯-精选资讯2");
    Show_Location_Three = new Meta(3, "链云PC端看资讯-精选资讯3");
    Show_Location_Four = new Meta(4, "链云PC端看资讯-精选资讯4");
    Show_Location_Five = new Meta(5, "链云PC端看资讯-精选资讯5");
}
export const Show_USER_PC_Type = new ShowUserPCType();

/**
 * 资讯种类
 */
class Category extends UltMeta {
    ANNOUNCEMENT = new Meta(1, "公告");
    INFORMATION = new Meta(2, "资讯");
    SAND_ACADEMY = new Meta(3, "砂石学院");
}
export const CATEGORY = new Category();

/**
 * 资讯状态
 */
class Status extends UltMeta {
    /**
     * 草稿
     */
    DRAFT = new Meta(0, "草稿");
    /**
     * 已发布
     */
    PUBLISHED = new Meta(1, "已发布");
}

export const STATUS = new Status();
